/**
 * Nombres de acción que atiende la Function `games`, la Function genérica de
 * juegos (dados por ahora; a futuro más juegos que no sean de Iluri). No
 * confundir con el runtime RSGame de Iluri (la Function `iluri`), que llama
 * siempre con un `functionId` de `iluri` explícito desde `game-gateway.ts`
 * del sitio `juegos-rs` — ambas se separaron el 5 sept 2026, ver
 * `functions.md` de `rs-functions`.
 *
 * Estas tres viven en `dice-gateway.ts`, que hasta esa fecha le pegaba a
 * `management-command` por default. `dice_actions.py` se mudó a `games`
 * porque tirar dados es una acción de juego, no de administración —
 * `command-gateway.ts` usa esta lista para enrutarlas sin que
 * `dice-gateway.ts` tenga que pasar el `functionId` a mano.
 */
export const GAMES_ACTIONS: ReadonlySet<string> = new Set([
  'roll_dice',
  'get_dice_effect',
  'get_veintiuno_outcome_sound',
]);
